import {Directive, effect, input} from "@angular/core";
import {DetachableChangeDetection} from "../shared-components/panel-components/detachable-cd/detachable-change-detection";

@Directive({
	selector: "[appDetachableChangeDetection]",
	standalone: false,
})
export class DetachableChangeDetectionDirective {
	public readonly open = input.required<boolean>();
	public readonly component = input.required<DetachableChangeDetection>();

	private readonly detachEffect = effect(() => {
		const open = this.open();
		const component = this.component();

		if (open) {
			component.attachToCD();
		} else {
			component.detachFromCD();
		}
	});
}
